<template>
  <layout-main-inner title="盘库管理">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <ent-warehouse-auto-select
          v-model="config.warehouseNo"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input
          v-model="config.code"
          placeholder="请输入盘库单号"
          style="width: 200px;margin-left: 10px;">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          label="盘库单号"
          prop="code"
          width="200">
        </el-table-column>
        <el-table-column
          label="仓库"
          prop="warehouseNo">
          <template slot-scope="{row}">
            {{ row.warehouseNo | warehouseName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100">
          <template slot-scope="{row}">
            {{ row.status | checkStatusName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="备注">
          <template slot-scope="{row}">
            {{ row.bizDesc }}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="140">
          <template slot-scope="{row}">
            {{ row.createTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="105">
          <template slot-scope="{row}">
            <el-button
              type="warning"
              @click.native="outdetail(row)">
              查看明细
            </el-button>
            <!-- <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="outdetail(row)">查看明细</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <detail-modal ref="detail" />
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
import EntWarehouseAutoSelect from '../../components/business/ent-warehouse-auto-select.vue'
import DetailModal from './detail-modal.vue'

export default {
  name: 'InventoryCheckList',
  components: { EntWarehouseAutoSelect, DetailModal },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: '',
        warehouseNo: ''
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('outstock/checkorderlist', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    outdetail(row) {
      this.$refs.detail.fetch(row)
    }
  }
}
</script>
<style lang="stylus"></style>
